export default __webpack_public_path__ + "static/media/cd712bb0f45823e1a017e2acd3eacdda.svg";